import { win } from '@utils/win';
import { useEffect, useState } from 'react';
import {
  getTenantConfig,
  TENANT_THEME_LOADED_EVENT,
  TenantConfig,
} from '../util/tenantTheme';

// ts-unused-exports:disable-next-line
export const useTenantTheme = (): TenantConfig | null => {
  const [config, setConfig] = useState<TenantConfig | null>(getTenantConfig());

  useEffect(() => {
    const handleThemeLoaded = (): void => {
      setConfig(getTenantConfig());
    };

    win.addEventListener(TENANT_THEME_LOADED_EVENT, handleThemeLoaded);

    return () => {
      win.removeEventListener(TENANT_THEME_LOADED_EVENT, handleThemeLoaded);
    };
  }, []);

  return config;
};
